<template>
    <div class="secure-sign__container">
        <v-container>
            <s-s-form-header
                title="Denzapine Monitoring Service Patient Transfer Form from other Brand to Denzapine "
                document-number="PV01F04"
                version="10.0"
                effective-date="29 Feb 2024"
                review-date="29 Feb 2026"
                supersedes="9.0"
            ></s-s-form-header>
            <v-col class="text-center">
                <h1 class="mb-2">Denzapine Monitoring Service Patient Transfer Form from other Brand to Denzapine</h1>
                <h4 class="mb-8">
                    Please complete all form fields before submission of application. Missing information may result in
                    delays to patient transfer.
                </h4>
            </v-col>

            <v-col cols="12">
                <v-form ref="form" v-model="isFormValid" :disabled="isDisabled">
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Hospital / Pharmacy Details</h5>
                        </v-col>
                        <v-col cols="12" sm="12" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.transferringDenzapine"
                                label="This patient will be transferring to Denzapine from:"
                                mandatory
                                :rules="validationRules.transferringDenzapine"
                                :radio-data="[
                                    { label: 'Clozaril', value: 'Clozaril' },
                                    { label: 'Zaponex', value: 'Zaponex' },
                                ]"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="12" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.patientUseType"
                                label="This patient will be on:"
                                mandatory
                                :rules="validationRules.patientUseType"
                                :radio-data="[
                                    { label: 'Tablets', value: 'Tablets' },
                                    { label: 'Suspension', value: 'Suspension' },
                                ]"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0 pt-5">
                            <b-date-picker-store
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.dateOfTransfer"
                                label="Proposed Date of Transfer:"
                                :rules="validationRules.dateOfTransfer"
                                mandatory
                            ></b-date-picker-store>
                        </v-col>
                        <v-col cols="12" sm="12" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.bloodKits"
                                label="Barcodes / Blood kits should be sent to:"
                                mandatory
                                :rules="validationRules.bloodKits"
                                :radio-data="[
                                    { label: 'Pharmacy', value: 'Pharmacy' },
                                    { label: 'Collection Centre/Ward', value: 'Collection Centre/Ward' },
                                ]"
                            ></secure-sign-form-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Patient Details</h5>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.patientFirstName"
                                :rules="validationRules.patientFirstName"
                                label="Patient First Name:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.patientLastName"
                                :rules="validationRules.patientLastName"
                                label="Patient Last Name:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-date-picker-store
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.dateOfBirth"
                                label="Date of Birth:"
                                :rules="validationRules.dateOfBirth"
                                mandatory
                            ></b-date-picker-store>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.gender"
                                label="Gender:"
                                mandatory
                                :rules="validationRules.gender"
                                :radio-data="[
                                    { label: 'Male', value: 'Male' },
                                    { label: 'Female', value: 'Female' },
                                    { label: 'Other', value: 'Other' },
                                ]"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.monitoringFrequency"
                                label="Current Monitoring Frequency:"
                                mandatory
                                :rules="validationRules.monitoringFrequency"
                                :radio-data="[
                                    { label: 'Weekly', value: 'Weekly' },
                                    { label: 'Fortnightly', value: 'Fortnightly' },
                                    { label: 'Monthly', value: 'Monthly' },
                                ]"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.race"
                                label="Race:"
                                mandatory
                                :rules="validationRules.race"
                                :radio-data="[
                                    { label: 'Caucasian', value: 'Caucasian' },
                                    { label: 'Asian', value: 'Asian' },
                                    { label: 'Afro-Caribbean', value: 'Afro-Caribbean' },
                                    { label: 'Mixed', value: 'Mixed' },
                                    { label: 'Other, please specify', value: 'Other' },
                                ]"
                                connected-field="patientTransferFormFromBrandToDenzapine.otherRace"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.otherRace"
                                :rules="isRaceAdditionalFieldDisabled ? validationRules.otherRace : []"
                                label="Other, please specify"
                                :mandatory="isRaceAdditionalFieldDisabled"
                                :disabled="!isRaceAdditionalFieldDisabled"
                            ></b-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.ztasNumber"
                                :rules="validationRules.ztasNumber"
                                label="CPMS/ZTAS Number:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="12" class="py-0">
                            <p>
                                By signing this form, I confirm that the patient has been notified that their data will
                                be transferred to an alternative Clozapine supplier
                            </p>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Transfer Details - Prescriber Details</h5>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.nameOfPrescriber"
                                :rules="validationRules.nameOfPrescriber"
                                label="Name of Prescriber:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.gmcNumber"
                                :rules="validationRules.gmcNumber"
                                label="GMC Number:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.prescriberAddress"
                                :rules="validationRules.prescriberAddress"
                                label="Address:"
                                mandatory
                            ></b-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="8" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.prescriberEmailAddress"
                                :rules="validationRules.prescriberEmailAddress"
                                label="Email Address:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.prescriberTelephoneNumber"
                                :rules="validationRules.prescriberTelephoneNumber"
                                label="Telephone Number:"
                                mandatory
                            ></b-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Transfer Details - Pharmacy Details</h5>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.nameOfPharmacy"
                                :rules="validationRules.nameOfPharmacy"
                                label="Name of Pharmacy:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.pharmacyTelephoneNumber"
                                :rules="validationRules.pharmacyTelephoneNumber"
                                label="Telephone Number:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.pharmacyAddress"
                                :rules="validationRules.pharmacyAddress"
                                label="Address"
                                mandatory
                            ></b-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Transfer Details - Collection Centre Details</h5>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.centreAddress"
                                :rules="validationRules.centreAddress"
                                label="Address:"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="12" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.patientType"
                                label=""
                                mandatory
                                :rules="validationRules.patientType"
                                :radio-data="[
                                    { label: 'Inpatient', value: 'Inpatient' },
                                    { label: 'Outpatient', value: 'Outpatient' },
                                ]"
                                connected-field="patientTransferFormFromBrandToDenzapine.inpatientWard"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.inpatientWard"
                                :rules="isPatientTypeAdditionalFieldDisabled ? validationRules.inpatientWard : []"
                                label="If inpatient, please specify ward"
                                :mandatory="isPatientTypeAdditionalFieldDisabled"
                                :disabled="!isPatientTypeAdditionalFieldDisabled"
                            ></b-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.centrePhoneNumber"
                                :rules="validationRules.centrePhoneNumber"
                                label="Telephone Number:"
                                mandatory
                            ></b-input>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Diagnosis</h5>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.neutropenia"
                                label="Has the patient ever had an episode of neutropenia?"
                                mandatory
                                :rules="validationRules.neutropenia"
                                :radio-data="radioDataBinary"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.redStatus"
                                label="Does the patient have a confirmed red status in their history?"
                                mandatory
                                :rules="validationRules.redStatus"
                                :radio-data="radioDataBinary"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.beningEthnicNeutropenia"
                                label="Does the patient have Benign Ethnic Neutropenia (BEN)?"
                                mandatory
                                :rules="validationRules.beningEthnicNeutropenia"
                                :radio-data="radioDataBinary"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.treatmentResistantSchizophrenia"
                                label="Does the patient have Treatment Resistant Schizophrenia (TRS)?"
                                mandatory
                                :rules="validationRules.treatmentResistantSchizophrenia"
                                :radio-data="radioDataBinary"
                                connected-field="patientTransferFormFromBrandToDenzapine.diagnosisDetails"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.parkinsonDisease"
                                label="Does this patient have psychosis in Parkinson’s Disease?"
                                mandatory
                                :rules="validationRules.parkinsonDisease"
                                :radio-data="radioDataBinary"
                                connected-field="patientTransferFormFromBrandToDenzapine.diagnosisDetails"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.diagnosisDetails"
                                :rules="isDiagnosisAdditionalFieldDisabled ? validationRules.diagnosisDetails : []"
                                label="If no, please specify Diagnosis (an off-label agreement may be required):"
                                :mandatory="isDiagnosisAdditionalFieldDisabled"
                                :disabled="!isDiagnosisAdditionalFieldDisabled"
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.contraindicationsToClozapine"
                                label="Are there any contraindications to clozapine in the patient’s history?"
                                mandatory
                                :rules="validationRules.contraindicationsToClozapine"
                                :radio-data="radioDataBinary"
                                connected-field="patientTransferFormFromBrandToDenzapine.contraindicationsToClozapineDetails"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.contraindicationsToClozapineDetails"
                                :rules="
                                    isContraindicationsToClozapineAdditionalFieldDisabled
                                        ? validationRules.contraindicationsToClozapineDetails
                                        : []
                                "
                                label="If yes, please provide details (an off-label agreement may be required):"
                                :mandatory="isContraindicationsToClozapineAdditionalFieldDisabled"
                                :disabled="!isContraindicationsToClozapineAdditionalFieldDisabled"
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.boneMarrowFunction"
                                label="Has the patient had impaired bone marrow function?"
                                mandatory
                                :rules="validationRules.boneMarrowFunction"
                                :radio-data="radioDataBinary"
                            ></secure-sign-form-radio-group>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <secure-sign-form-radio-group
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.patientOutsideOfUK"
                                label="Is the patient transferring from outside of the UK?"
                                mandatory
                                :rules="validationRules.patientOutsideOfUK"
                                :radio-data="radioDataBinary"
                            ></secure-sign-form-radio-group>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Additional Information</h5>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-textarea
                                auto-grow
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.additionalInformation"
                                label=""
                                :rules="validationRules.additionalInformation"
                                mandotory
                            ></b-textarea>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <h5 class="patient-form-title">Consultant Psychiatrist</h5>
                            <p class="mt-5 font-weight-bold">
                                I confirm that the patient has been informed that (and has agreed to) his / her data
                                being held on file (whether in electronic or hard copy form). The patient is aware that
                                the data may be used to make decisions about their treatment.
                            </p>
                        </v-col>
                        <v-col cols="12" sm="8" class="py-0">
                            <b-input
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.consultantPsychiatristName"
                                :rules="validationRules.consultantPsychiatristName"
                                label="Name (please print):"
                                mandatory
                            ></b-input>
                        </v-col>
                        <v-col cols="12" sm="4" class="py-0">
                            <b-date-picker-store
                                hide-details
                                to-mutate="secure_sign_forms::patientTransferFormFromBrandToDenzapine.date"
                                label="Date"
                                :rules="validationRules.date"
                                mandatory
                            ></b-date-picker-store>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="8">
                            <secure-sign-form-signature-component
                                ref="signaturePad"
                                :form-type="form"
                                :is-disabled="isDisabled"
                            ></secure-sign-form-signature-component>
                        </v-col>
                        <v-col
                            v-if="!isDisabled"
                            cols="12"
                            sm="4"
                            class="d-flex flex-column justify-content-end align-items-center"
                        >
                            <secure-sign-form-recaptcha
                                ref="recaptcha"
                                :valid-recaptcha="validRecaptcha"
                                :is-disabled="isDisabled"
                                @expired="expired"
                                @verify="onRecaptchaVerify"
                            ></secure-sign-form-recaptcha>
                            <v-btn
                                :loading="loading"
                                class="mt-2"
                                max-width="304px"
                                width="100%"
                                size="x-large"
                                color="primary"
                                :disabled="isDisabled"
                                @click="submit"
                                >Submit
                            </v-btn>
                        </v-col>
                    </v-row>
                    <s-s-form-footer>
                        <p>
                            Should you have any queries, please do not hesitate to contact the Denzapine Monitoring
                            Service Team on 0333 200 4141
                        </p>
                        <p>Job Code: UK-Denz-2300031 Date of prep: Feb 2024</p>
                    </s-s-form-footer>
                </v-form>
            </v-col>
        </v-container>
    </div>
</template>

<script>
import SSFormHeader from './partials/SSFormHeader.vue';
import SSFormFooter from './partials/SSFormFooter.vue';

let formControl = require('./mixins/FormControl.js').default;
export default {
    components: { SSFormFooter, SSFormHeader },
    mixins: [formControl],
    data() {
        return {
            validationRules: {
                transferringDenzapine: [(v) => !!v || t('users::validation.field.required')],
                patientUseType: [(v) => !!v || t('users::validation.field.required')],
                dateOfTransfer: [(v) => !!v || t('users::validation.field.required')],
                bloodKits: [(v) => !!v || t('users::validation.field.required')],
                patientFirstName: [(v) => !!v || t('users::validation.field.required')],
                patientLastName: [(v) => !!v || t('users::validation.field.required')],
                dateOfBirth: [(v) => !!v || t('users::validation.field.required')],
                monitoringFrequency: [(v) => !!v || t('users::validation.field.required')],
                race: [(v) => !!v || t('users::validation.field.required')],
                otherRace: [(v) => !!v || t('users::validation.field.required')],
                ztasNumber: [(v) => !!v || t('users::validation.field.required')],
                nameOfPrescriber: [(v) => !!v || t('users::validation.field.required')],
                gmcNumber: [(v) => !!v || t('users::validation.field.required')],
                prescriberAddress: [(v) => !!v || t('users::validation.field.required')],
                prescriberEmailAddress: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.email],
                prescriberTelephoneNumber: [(v) => !!v || t('users::validation.field.required')],
                nameOfPharmacy: [(v) => !!v || t('users::validation.field.required')],
                pharmacyAddress: [(v) => !!v || t('users::validation.field.required')],
                pharmacyTelephoneNumber: [(v) => !!v || t('users::validation.field.required')],
                centreAddress: [(v) => !!v || t('users::validation.field.required')],
                patientType: [(v) => !!v || t('users::validation.field.required')],
                inpatientWard: [(v) => !!v || t('users::validation.field.required')],
                centrePhoneNumber: [(v) => !!v || t('users::validation.field.required')],
                neutropenia: [(v) => !!v || t('users::validation.field.required')],
                redStatus: [(v) => !!v || t('users::validation.field.required')],
                beningEthnicNeutropenia: [(v) => !!v || t('users::validation.field.required')],
                treatmentResistantSchizophrenia: [(v) => !!v || t('users::validation.field.required')],
                parkinsonDisease: [(v) => !!v || t('users::validation.field.required')],
                diagnosisDetails: [(v) => !!v || t('users::validation.field.required')],
                contraindicationsToClozapine: [(v) => !!v || t('users::validation.field.required')],
                contraindicationsToClozapineDetails: [(v) => !!v || t('users::validation.field.required')],
                boneMarrowFunction: [(v) => !!v || t('users::validation.field.required')],
                patientOutsideOfUK: [(v) => !!v || t('users::validation.field.required')],
                additionalInformation: [(v) => !!v || t('users::validation.field.required')],
                consultantPsychiatristName: [(v) => !!v || t('users::validation.field.required')],
                signature: [(v) => !!v || t('users::validation.field.required')],
                date: [(v) => !!v || t('users::validation.field.required')],
                gender: [(v) => !!v || t('users::validation.field.required')],
            },
            radioDataBinary: [
                { label: 'Yes', value: 'Yes' },
                { label: 'No', value: 'No' },
            ],
            isFormValid: false,
            formType: 'patient-transfer-form-from-brand-to-denzapine',
            form: 'patientTransferFormFromBrandToDenzapine',
        };
    },
    computed: {
        isRaceAdditionalFieldDisabled: {
            get() {
                return this.$store.state.secure_sign_forms.patientTransferFormFromBrandToDenzapine.race === 'Other';
            },
        },
        isDiagnosisAdditionalFieldDisabled: {
            get() {
                return (
                    this.$store.state.secure_sign_forms.patientTransferFormFromBrandToDenzapine.parkinsonDisease ===
                        'No' &&
                    this.$store.state.secure_sign_forms.patientTransferFormFromBrandToDenzapine
                        .treatmentResistantSchizophrenia === 'No'
                );
            },
        },
        isContraindicationsToClozapineAdditionalFieldDisabled: {
            get() {
                return (
                    this.$store.state.secure_sign_forms.patientTransferFormFromBrandToDenzapine
                        .contraindicationsToClozapine === 'Yes'
                );
            },
        },
        isPatientTypeAdditionalFieldDisabled: {
            get() {
                return (
                    this.$store.state.secure_sign_forms.patientTransferFormFromBrandToDenzapine.patientType ===
                    'Inpatient'
                );
            },
        },
    },
    created() {
        this.getFormData();
    },
};
</script>

<style></style>
